<app-price-detail
  class="price-box"
  [style.background-color]="backgroundColor"
  [ngClass]="{
  'play-price-box': isPlay || isBannerPriceBox,
  'price-box--size__default': rendition === StreamingBundleProductTypeRendition || rendition === DisneyStandaloneProductTypeRendition || rendition === NetflixStandaloneProductTypeRendition,
  'price-box--color__white': rendition === StreamingBundleProductTypeRendition,
  'price-box--color__red': rendition === NetflixStandaloneProductTypeRendition,
  'price-box--color__blue': rendition === DisneyStandaloneProductTypeRendition
  }"
  [rendition]="rendition"
  [promoTextKey]="promoTextKey"
  [priceDetail]="priceDetail"
  [isPlay]="isPlay"
  [omapiId]="omapiId">
</app-price-detail>

